<template>
	<Flyout
		title="User Settings"
		parentTag="form"
		:display="display"
		@show="closeUserSettingFlyout"
		:novalidate="'novalidate'"
	>
		<template #flyout-content>
			<div class="user-settings__users-info">
				<UserForm
					v-model="userData"
					@hasError="updateHasErrorValue"
					:errorMessage="errorMessage"
					:showNotificationError="showNotificationError"
				/>
			</div>

			<UserRolesPermissions v-model="userData" />
			<p
				class="permission-users__link-to-role-page"
				v-if="hasRolesPermission"
			>
				You can edit roles on the
				<a class="link" v-on:click.prevent="clickHandler"
					>Manage Roles</a
				>
				page.
			</p>
		</template>
		<template #flyout-footer>
			<ButtonGroup
				:items="[
					{
						className: 'btn--primary',
						labelText: 'Save',
						btnClick: saveAction,
						disabled: hasError
					},
					{
						className: 'btn--link',
						labelText: 'Cancel',
						btnClick: cancelAction
					}
				]"
			/>
		</template>
	</Flyout>
</template>

<script>
import Flyout from '@/components/shells/flyout/flyout';
import ButtonGroup from '@/components/forms/button/button-group';
import UserForm from './user-form.vue';
import UserRolesPermissions from './user-roles-permissions.vue';
import { mapActions } from 'vuex';
import _ from 'lodash';

export default {
	name: 'UserEditFlyout',
	components: {
		Flyout,
		ButtonGroup,
		UserForm,
		UserRolesPermissions
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		display: {
			type: Boolean,
			default: false
		},
		validateBeforeClose: {
			type: Boolean,
			default: false
		},
		user: {
			type: Object
		}
	},
	data() {
		return {
			hasError: true,
			userData: {},
			showNotificationError: false,
			errorMessage: ''
		};
	},
	computed: {
		hasRolesPermission() {
			return this.validatePermission([
				'roles.create',
				'roles.update',
				'roles.delete'
			]);
		}
	},
	methods: {
		...mapActions('users', { updateUserAction: 'updateUser' }),

		closeUserSettingFlyout(e) {
			if (!this.validateBeforeClose) {
				this.cancelAction(e);
			}
		},
		async saveAction(e) {
			if (e) e.preventDefault();
			const roles = _.union(
				this.userData.internalIds,
				this.userData.consultantIds
			).map(id => ({ roleId: id }));

			let user = _.omit(this.userData, ['internalIds', 'consultantIds']);
			Object.assign(user, { roles });

			await this.updateUserAction(user).then(response => {
				const { isSuccessful } = response;

				if (isSuccessful) {
					this.cancelAction();
				}
				if (!isSuccessful) {
					const { message } = response;
					this.errorMessage = message;
					this.showNotificationError = true;
				}
			});
		},
		cancelAction(e) {
			if (e) e.preventDefault();
			if (this.showNotificationError) {
				this.showNotificationError = false;
			}
			this.$emit('show', false);
		},

		clickHandler() {
			const routeData = this.$router.resolve({
				path: '/roles'
			});
			window.open(routeData.href, '_blank');
		},
		updateHasErrorValue(val) {
			const { isCorrupted } = this.userData;
			if (isCorrupted) {
				this.hasError = false;
				return;
			}
			const areEqual = _.isEqual(this.user, this.userData);
			this.hasError = val || areEqual;
		}
	},
	watch: {
		display: {
			immediate: true,
			handler(val) {
				if (val) {
					this.validatePermission('users.update', true);
					this.userData = _.cloneDeep(this.user);
				}
			}
		},
		userData: {
			deep: true,
			handler() {
				this.updateHasErrorValue();
			}
		}
	}
};
</script>
<style lang="scss" scoped>
/**
	* [Description]
    *
    * Users Permissions
    * Can use SCSS variables = TRUE
    *
 */

/*------------------------------------*\
  #BASE
\*------------------------------------*/

.user-settings {
	&__users-info {
		margin-bottom: $gutter-xl;
	}
}

.permission-users__link-to-role-page {
	text-align: right;
	line-height: $line-height-ratio;
	font-size: $flyout-content-font-size;
	grid-column-start: 1;
	grid-column-end: 3;

	@include mq($from: lg) {
		grid-column-start: 1;
		grid-column-end: 5;
	}
}
</style>
